import { IUserLoginInfo } from 'redhotpie-shared-lib/interfaces/IUser';
import TravelPlan from './travelPlans';
import { NOTIFICATIONS } from 'redhotpie-shared-lib/constants/constants';
import { IFriend } from 'redhotpie-shared-lib/interfaces/IFriendUser';

export interface INotificationGroupInvite {
  profile?: IFriend;
  title: string;
  inviteID: number;
  parentID: number;
  parentType: string;
  dateCreated: string;
  contentType: string;
  type: string;
  itemTotal?: number;
}

export default class NotificationGroupInvite {
  profile?: IUserLoginInfo;
  title: string;
  inviteID: number;
  parentID: number;
  parentType: string;
  dateCreated: string;
  contentType: string;
  type: string;
  itemTotal?: number;

  constructor() {
    this.profile = undefined;
    this.title = '';
    this.inviteID = -1;
    this.parentID = -1;
    this.parentType = '';
    this.dateCreated = '';
    this.contentType = '';
    this.type = '';
  }

  static mappingObect(obj: any): INotificationGroupInvite {
    return {
      profile: TravelPlan.mappingProfile(obj.Profile),
      title: obj.Title,
      inviteID: obj.InviteID,
      parentID: obj.ParentID,
      parentType: obj.ParentType,
      dateCreated: obj.DateCreated,
      contentType:
        obj.ContentType || obj.ParentType === 'Group'
          ? NOTIFICATIONS.TYPE_OF_GROUP_NOTIFICATION.CLUB_INVITATION
          : NOTIFICATIONS.TYPE_OF_GROUP_NOTIFICATION.EVENT_INVITATION,
      type: obj.Type || '',
    };
  }

  static mappingList(items: any): INotificationGroupInvite[] {
    return items.map((item: any) => {
      return NotificationGroupInvite.mappingObect(item);
    });
  }
}
